import createStyles from '@material-ui/styles/createStyles'
import { Theme } from 'Theme'

export default ({ spacing, palette }: typeof Theme) => createStyles({

});